import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-crazy',
    template: `<h2>Crazy component</h2>
<app-crazy-radio></app-crazy-radio>
`,
    styles: []
})
export class CrazyComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
